import { useQuery } from '@tanstack/react-query'
import getResourceUrl from './api/resource/getResourceUrl'

const useResource = (resourceKey: string | undefined) => {
  const url = resourceKey ? getResourceUrl(resourceKey) : undefined

  const query = useQuery({
    queryKey: ['resourceContent', resourceKey],
    queryFn: async () => {
      const response = await fetch(url!)
      if (!response.ok) throw new Error(`Failed to fetch resource: ${response.status}`)
      return response.text()
    },
    enabled: !!url,
  })

  return { content: query.data, isLoading: query.isLoading, error: query.error }
}

export default useResource
